import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button, Dialog, DialogContent, DialogActions,
} from '../../../common/components';

const S = {
  Dialog: styled(Dialog)`
    .paper {
      width: 480px;
    }
  `,
  Paragraph: styled.p`
    margin-bottom: 40px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    line-height: 1.53;
  `,
  CancelButton: styled(Button)`
    height: 40px;
    min-height: 40px;
    color: ${({ theme }) => theme.palette.grey[700]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
  ConfirmButton: styled(Button)`
    height: 40px;
    min-height: 40px;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
};

const NavigationDialog = ({ open, onClose, onConfirm }) => (
  <S.Dialog open={open} onClose={onClose}>
    <DialogContent>
      <S.Paragraph>
        가정통신문 작성을 그만두시겠습니까?
        <br />
        저장하지 않은 가정통신문은 삭제됩니다.
      </S.Paragraph>
    </DialogContent>
    <DialogActions>
      <S.CancelButton type="button" variant="outlined" onClick={onClose}>
        취소
      </S.CancelButton>
      <S.ConfirmButton
        type="submit"
        color="primary"
        variant="contained"
        onClick={onConfirm}
      >
        확인
      </S.ConfirmButton>
    </DialogActions>
  </S.Dialog>
);

NavigationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

NavigationDialog.defaultProps = {
  onClose: () => {},
  onConfirm: () => {},
};

export default NavigationDialog;
